import React from 'react';
import { useField } from 'formik';
import { ValidationMessage } from '../../../Helpers/validation/validationMessage';

export const FormikInputField = ({ label, ...props }) => {

  const [field, meta] = useField(props);

  return (
    <>
      <input {...field} {...props} aria-required="true" />
      <ValidationMessage {...meta} />
    </>
  )
}